import React from 'react';
import { Sparkles, Shield, Zap, Users } from 'lucide-react';

const features = [
  {
    icon: Sparkles,
    title: 'Epic Team Names',
    description: 'Generate powerful and memorable names for your superhero squad.'
  },
  {
    icon: Shield,
    title: 'Multiple Themes',
    description: 'Choose from cosmic, vigilante, mystic, or tech-based themes.'
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'Create unique superhero team names in seconds.'
  },
  {
    icon: Users,
    title: 'Team Dynamics',
    description: 'Names that reflect your team\'s powers and purpose.'
  }
];

export default function SuperheroFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Why Choose Our Superhero Name Generator?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg border border-violet-200 hover:shadow-lg transition-shadow">
              <feature.icon className="w-12 h-12 text-violet-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}